module.exports = __webpack_public_path__ + "img/Patch21.c4f1a3ca.webp";